import i18n from "../i18n/i18n";

export function validateResetPasswordInput(email, code, newPassword) {
  if (!code && !newPassword) {
    return i18n.t("errors.pleaseEnterCodeAndPassword", "Please enter reset code and new password.");
  }
  if (!code) {
    return i18n.t("errors.pleaseEnterResetCode", "Please enter the reset code.");
  }
  if (!newPassword) {
    return i18n.t("errors.pleaseEnterNewPassword", "Please enter your new password.");
  }

  const passwordRegex =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*_\-+={[}\]|\\:;"'<,>.?/]).{5,}$/;

  if (!passwordRegex.test(newPassword)) {
    return i18n.t(
      "errors.passwordStrength",
      "Password must be at least 5 characters long and include at least one uppercase letter, one number, and one special symbol."
    );
  }

  return null;
}

export function parseResetPasswordError(error) {
  const status = error?.status ?? error?.response?.status;

  if (!status) {
    return i18n.t("errors.unexpectedError", "An unexpected error occurred. Please try again later.");
  }

  switch (status) {
    case 404:
      return i18n.t("errors.invalidResetCode", "Invalid reset code.");
    case 400:
      return i18n.t("errors.invalidRequest", "Invalid request. Please check your input.");
    case 500:
      return i18n.t("errors.serverError", "Server error. Please try again later.");
    case 502:
    case 503:
    case 504:
      return i18n.t("errors.serviceUnavailable", "Service is temporarily unavailable. Please wait and try again.");
    default:
      return i18n.t("errors.genericError", "An error occurred. Please try again.");
  }
}
